import { browserLocalPersistence, browserSessionPersistence } from 'firebase/auth';

import { type PeristenceTypeHandlers } from './interface';

export {
  EmailAuthProvider,
  onAuthStateChanged,
  reauthenticateWithCredential,
  setPersistence,
  signInWithCustomToken,
  signInWithEmailAndPassword,
  signOut,
  updatePassword,
} from 'firebase/auth';

export const persistence: PeristenceTypeHandlers = {
  default: {
    getItem: (key: string) => localStorage.getItem(key),
    setItem: (key: string, value: string) => localStorage.setItem(key, value),
    type: browserLocalPersistence,
  },
  impersonate: {
    getItem: (key: string) => sessionStorage.getItem(key),
    setItem: (key: string, value: string) => sessionStorage.setItem(key, value),
    type: browserSessionPersistence,
  },
};
